import React from "react";
import { useI18n } from "@/lib/i18n";
import { Globe } from "lucide-react";

export default function LanguageToggle({ dark = false }) {
  const { lang, setLang } = useI18n();
  const toggle = () => setLang(lang === "en" ? "hi" : "en");
  return (
    <button onClick={toggle} data-testid="lang-toggle"
      className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-full border text-xs font-semibold transition-colors ${
        dark ? "border-white/20 text-white hover:bg-white hover:text-black" : "border-[var(--line)] text-zinc-700 hover:bg-zinc-900 hover:text-white"
      }`}>
      <Globe size={14} />
      {lang === "en" ? "EN" : "हिं"} · <span className="opacity-60">{lang === "en" ? "हिं" : "EN"}</span>
    </button>
  );
}
